import styled from 'styled-components';

import { A } from '@main/pc-core-components';
import { responsive, sp } from '@main/theme';

/**
 * The Text Wrapper
 */
export const TextWrapper = styled.div`
  margin-bottom: ${sp(3)};

  ${responsive.atLeastTablet} {
    width: 55%;
    margin: 0;
  }

  ${responsive.atLeastDesktop} {
  }
`;

/**
 * The Take Control Wrapper
 */
export const TakeControlWrapper = styled(A)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
`;

/**
 * The Header Wrapper
 */
export const HeaderWrapper = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: ${sp(2)};
`;

/**
 * The Body Wrapper
 */
export const BodyWrapper = styled.body`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${sp(2)};
`;

/**
 * The ContactSupportBanner wrapper
 */
export const ContactSupportBannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; include if we end up wanting to trim button width in mobile */
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  padding: ${sp(3)} ${sp(3)} ${sp(5)} ${sp(3)};

  ${responsive.atLeastTablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${sp(5)} ${sp(4)};
  }
`;
